import { RouterView } from "vue-router";
import { contractTemplateRouter } from "./contract-template/contract-template.router";
import { contractManagementRouter } from "./contract-management/contract-management.router";
import { contractCreateRouter } from "./contract-create/contract-create.router";
import { customerManagementRouter } from "./customer-management/customer-management.router";
export const signaturesRouter = {
  path: "/signatures",
  name: "signatures",
  redirect: "/signatures/contract-template/list",
  component: RouterView,
  meta: { title: "电子签", icon: "member" },
  children: [
    ...contractTemplateRouter,
    ...contractManagementRouter,
    ...contractCreateRouter,
    ...customerManagementRouter,
  ],
};
